import { getAmplitudeInstance } from '../amplitudeHelpers';
import VisitationMonth from '../enums/VisitationMonth';

type logTrailDetailsVisitationMonthSelectedParams = {
  trail_id: number;
  visitation_month_selected: VisitationMonth;
};

/**
 * User select or hover over a month in Visitation module.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.visitation_month_selected - Month selected or hovered over by user in Visitation module.
 */
const logTrailDetailsVisitationMonthSelected = (
  { trail_id, visitation_month_selected }: logTrailDetailsVisitationMonthSelectedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details visitation month selected',
    { 'trail id': trail_id, 'visitation month selected': visitation_month_selected },
    callback
  );
};

export default logTrailDetailsVisitationMonthSelected;
